import { defineStore } from 'pinia'
import type { IMessage } from 'src/interfaces/common'
import { computed, ref } from 'vue'
import { useLoader } from 'src/hooks/useLoader'
import { LOADERS } from 'src/config/constants'

export const useClientMessagingStore = defineStore('client.messaging', () => {
  const isInitialzed = ref(false)
  const messages = ref<IMessage[]>([])
  const parentPortalUnreadMessages = ref<Record<string, number>>({})

  const unreadMessagesCount = computed<number>(() => {
    if (!parentPortalUnreadMessages.value) return 0
    return parentPortalUnreadMessages.value['Center'] || 0
  })

  const setMessages = (newMessages: IMessage[]) => {
    messages.value = newMessages
  }

  const setUnreadMessages = (unreadMessages: Record<string, number>) => {
    parentPortalUnreadMessages.value = unreadMessages
  }

  const clearUnreadMessages = () => {
    parentPortalUnreadMessages.value = {}
  }

  const setIsInitialized = (initialized: boolean) => {
    isInitialzed.value = initialized
  }

  const initialize = async () => {
    if (isInitialzed.value) return

    const { useFetchLoader: fetchParentPortalUnreadMessagesCount } = useLoader<
      Record<string, number>
    >(LOADERS.per, {
      uri: 'parentPortalUnreadMessagesCount',
    })

    try {
      const result = await fetchParentPortalUnreadMessagesCount()
      if (result) {
        parentPortalUnreadMessages.value = result
      }
      isInitialzed.value = true
    } catch {
      // Don't set initialized to true on error, allow retry
    }
  }

  return {
    isInitialzed,
    messages,
    unreadMessagesCount,
    parentPortalUnreadMessages,
    setMessages,
    setUnreadMessages,
    clearUnreadMessages,
    setIsInitialized,
    initialize,
  }
})
